const API_URL = process.env.REACT_APP_API_URL
const API_KEY = process.env.REACT_APP_API_KEY

const headers = {
  'Accept': 'application/json',
  'Authorization': API_KEY,
}

// create an account
export const createAccount = (params) =>
  fetch(`${API_URL}/api/create_user`, {
    method: 'POST',
    headers: {
      ...headers,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify( params )
  }).then(res => res.json())


// signinWithPassword
export const signinWithPassword = (params) =>
  fetch(`${API_URL}/api/login_with_email_password`, {
    method: 'POST',
    headers: {
      ...headers,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify( params )
  }).then(res => res.json())

// signin with token
export const signinWithToken = (params) =>
  fetch(`${API_URL}/api/login_with_token`, {
    method: 'POST',
    headers: {
      ...headers,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify( params )
  }).then(res => res.json())

// logout
export const logout = (params) =>
  fetch(`${API_URL}/api/logout`, {
    method: 'POST',
    headers: {
      ...headers,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify( params )
  }).then(res => res.json())

// validateEmail
export const validateEmail = (params) =>
  fetch(`${API_URL}/api/validate_email`, {
    method: 'POST',
    headers: {
      ...headers,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify( params )
  }).then(res => res.json())





// getUserEmail
export const getUserEmail = (params) =>
  fetch(`${API_URL}/api/get_user_email`, {
    method: 'POST',
    headers: {
      ...headers,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify( params )
  }).then(res => res.json())


// updatePassword
export const updatePassword = (params) =>
  fetch(`${API_URL}/api/update_password`, {
    method: 'POST',
    headers: {
      ...headers,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify( params )
  }).then(res => res.json())

// getWakachi
export const getWakachi = (params) =>
  fetch(`${API_URL}/api/get_wakachi`, {
    method: 'POST',
    headers: {
      ...headers,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify( params )
  }).then(res => res.json())


// getDeepSpeechTokens
export const getDeepSpeechTokens = (params) =>
  fetch(`${API_URL}/api/get_deepspeech_tokens`, {
    method: 'POST',
    headers: {
      ...headers,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify( params )
  }).then(res => res.json())

// toggleKeyStatus
export const toggleKeyStatus = (params) =>
  fetch(`${API_URL}/api/toggle_key_status`, {
    method: 'POST',
    headers: {
      ...headers,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify( params )
  }).then(res => res.json())

// updateTokenMemo
export const updateTokenMemo = (params) =>
  fetch(`${API_URL}/api/update_token_memo`, {
    method: 'POST',
    headers: {
      ...headers,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify( params )
  }).then(res => res.json())

// getApiUsage
export const getApiUsage = (params) =>
  fetch(`${API_URL}/api/get_api_usage`, {
    method: 'POST',
    headers: {
      ...headers,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify( params )
  }).then(res => res.json())

// getEnginePrediction
export const getEnginePrediction = (params) =>
  fetch(`${API_URL}/api/get_engine_prediction`, {
    method: 'POST',
    headers: {
      ...headers,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify( params )
  }).then(res => res.json())


// testClipWithLatestAPI
export const testClipWithLatestAPI = (params) =>
  fetch(`${API_URL}/api/test_clip_with_api`, {
    method: 'POST',
    headers: {
      ...headers,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify( params )
  }).then(res => res.json())

// getPaymentHistory
export const getPaymentHistory = (params) =>
  fetch(`${API_URL}/api/get_payment_history`, {
    method: 'POST',
    headers: {
      ...headers,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify( params )
  }).then(res => res.json())

// subscribeApi
export const subscribeApi = (params) =>
  fetch(`${API_URL}/api/stripe-create-subscription`, {
    method: 'POST',
    headers: {
      ...headers,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify( params )
  }).then(res => res.json())


// cancelSubscription
export const cancelSubscription = (params) =>
  fetch(`${API_URL}/api/cancel_subscription`, {
    method: 'POST',
    headers: {
      ...headers,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify( params )
  }).then(res => res.json())

// _paymentMethodConformed
export const paymentMethodConformed = (params) =>
  fetch(`${API_URL}/api/payment_method_conformed`, {
    method: 'POST',
    headers: {
      ...headers,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify( params )
  }).then(res => res.json())


// checkSubscriptionStatus
export const checkSubscriptionStatus = (params) =>
  fetch(`${API_URL}/api/check_subscription_status`, {
    method: 'POST',
    headers: {
      ...headers,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify( params )
  }).then(res => res.json())

// purchaseEvalService
export const purchaseEvalService = (params) =>
  fetch(`${API_URL}/api/purchase_eval_service`, {
    method: 'POST',
    headers: {
      ...headers,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify( params )
  }).then(res => res.json())

// getSubscriptions
export const getSubscriptions = (params) =>
  fetch(`${API_URL}/api/get_subscriptions`, {
    method: 'POST',
    headers: {
      ...headers,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify( params )
  }).then(res => res.json())

// updateSubscriptionPaymentMethod
export const updateSubscriptionPaymentMethod = (params) =>
  fetch(`${API_URL}/api/update_subscription_payment_method`, {
    method: 'POST',
    headers: {
      ...headers,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify( params )
  }).then(res => res.json())

// recreateAPIKey
export const recreateAPIKey = (params) =>
  fetch(`${API_URL}/api/recreate_api_key`, {
    method: 'POST',
    headers: {
      ...headers,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify( params )
  }).then(res => res.json())


// email_inquiry_received
export const emailInquirySend = (params) =>
  fetch(`https://shabelab.com/api/email_inquiry_received`, {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Authorization': "ivvP2rehgjKJNksu",
      'Content-Type': 'application/json'
    },
    body: JSON.stringify( params )
  }).then(res => res.json())

// addOneWord2Dict
export const addOneWord2Dict = (params) =>
  fetch(`${API_URL}/api/add_one_word_into_dict`, {
    method: 'POST',
    headers: {
      ...headers,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify( params )
  }).then(res => res.json())

// getVocabList
export const getVocabList = (params) =>
  fetch(`${API_URL}/api/get_dictionary_vocabs`, {
    method: 'POST',
    headers: {
      ...headers,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify( params )
  }).then(res => res.json())

// deleteOneWordFromDict
export const deleteOneWordFromDict = (params) =>
  fetch(`${API_URL}/api/delete_one_word_from_dict`, {
    method: 'POST',
    headers: {
      ...headers,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify( params )
  }).then(res => res.json())



// updateVocabUpdatedAt
export const updateVocabUpdatedAt = (params) =>
  fetch(`${API_URL}/api/update_vocab_updatedat`, {
    method: 'POST',
    headers: {
      ...headers,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify( params )
  }).then(res => res.json())

// toggleDoOnIgigoExists
export const toggleDoOnIgigoExists = (params) =>
  fetch(`${API_URL}/api/toggle_vocab_kanji_uncertain`, {
    method: 'POST',
    headers: {
      ...headers,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify( params )
  }).then(res => res.json())

// checkPotentialDictVocab
export const checkPotentialDictVocab = (params) =>
  fetch(`${API_URL}/api/check_potential_dict_vocab`, {
    method: 'POST',
    headers: {
      ...headers,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify( params )
  }).then(res => res.json())

// addVocabsToCustomDictonary
export const addVocabsToCustomDictonary = (params) =>
  fetch(`${API_URL}/api/add_vocabs_to_custom_dictionary`, {
    method: 'POST',
    headers: {
      ...headers,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify( params )
  }).then(res => res.json())

// addVocabsToCustomDictonary2
export const addVocabsToCustomDictonary2 = (params) =>
  fetch(`${API_URL}/api/add_vocabs_to_custom_dictionary_from_drafts`, {
    method: 'POST',
    headers: {
      ...headers,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify( params )
  }).then(res => res.json())

// getApiInfoFromKey
export const getApiInfoFromKey = (params) =>
  fetch(`${API_URL}/api/get_api_info_from_key`, {
    method: 'POST',
    headers: {
      ...headers,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify( params )
  }).then(res => res.json())

// toggleImportantWord
export const toggleImportantWord = (params) =>
  fetch(`${API_URL}/api/toggle_vocab_importance`, {
    method: 'POST',
    headers: {
      ...headers,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify( params )
  }).then(res => res.json())

//
//
//

// naranciaUploadAudio
export const naranciaUploadAudio = (data) =>
  fetch(`${API_URL}/api/narancia_upload_audio`, {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Authorization': API_KEY,
    },
    body: data
  }).then(res => res.json())

// getNaranciaList
export const getNaranciaList = (params) =>
  fetch(`${API_URL}/api/get_narancia_list`, {
    method: 'POST',
    headers: {
      ...headers,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify( params )
  }).then(res => res.json())

// transcriptForNarancia
export const transcriptForNarancia = (params) =>
  fetch(`${API_URL}/api/transcript_for_narancia`, {
    method: 'POST',
    headers: {
      ...headers,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify( params )
  }).then(res => res.json())

// updateNaranciaOne
export const updateNaranciaOne = (params) =>
  fetch(`${API_URL}/api/update_narancia_one`, {
    method: 'POST',
    headers: {
      ...headers,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify( params )
  }).then(res => res.json())

// narantiaToggleChecked
export const narantiaToggleChecked = (params) =>
  fetch(`${API_URL}/api/narantia_toggle_checked`, {
    method: 'POST',
    headers: {
      ...headers,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify( params )
  }).then(res => res.json())

// getNaranciaChunks
export const getNaranciaChunks = (params) =>
  fetch(`${API_URL}/api/get_narancia_chunks`, {
    method: 'POST',
    headers: {
      ...headers,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify( params )
  }).then(res => res.json())

// getNaranciaChunkOne
export const getNaranciaChunkOne = (params) =>
  fetch(`${API_URL}/api/get_narancia_chunk_one`, {
    method: 'POST',
    headers: {
      ...headers,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify( params )
  }).then(res => res.json())

// getNaranciaKanaKanjiPairFromWords
export const getNaranciaKanaKanjiPairFromWords = (params) =>
  fetch(`${API_URL}/api/get_narancia_kanakanji_pair_from_words`, {
    method: 'POST',
    headers: {
      ...headers,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify( params )
  }).then(res => res.json())

// processNaranciaEvalTexts
export const processNaranciaEvalTexts = (params) =>
  fetch(`${API_URL}/api/process_narantia_eval_texts`, {
    method: 'POST',
    headers: {
      ...headers,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify( params )
  }).then(res => res.json())

// setNaranciaNickname
export const setNaranciaNickname = (params) =>
  fetch(`${API_URL}/api/set_narancia_nickname`, {
    method: 'POST',
    headers: {
      ...headers,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify( params )
  }).then(res => res.json())

// getNaranciaOne
export const getNaranciaFileOne = (params) =>
  fetch(`${API_URL}/api/get_narantia_file_one`, {
    method: 'POST',
    headers: {
      ...headers,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify( params )
  }).then(res => res.json())

// createNewNaranciaVideo
export const createNewNaranciaVideo = (params) =>
  fetch(`${API_URL}/api/create_new_narancia_video`, {
    method: 'POST',
    headers: {
      ...headers,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify( params )
  }).then(res => res.json())

// updateApiPostParams
export const updateApiPostParams = (params) =>
  fetch(`${API_URL}/api/update_api_post_params`, {
    method: 'POST',
    headers: {
      ...headers,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify( params )
  }).then(res => res.json())

// generateNewApiKey
export const generateNewApiKey = (params) =>
  fetch(`${API_URL}/api/generate_new_api_key`, {
    method: 'POST',
    headers: {
      ...headers,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify( params )
  }).then(res => res.json())

// generateNewDictionary
export const generateNewDictionary = (params) =>
  fetch(`${API_URL}/api/generate_new_dictionary_key`, {
    method: 'POST',
    headers: {
      ...headers,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify( params )
  }).then(res => res.json())

// getSharableDictionaryList
export const getSharableDictionaryList = (params) =>
  fetch(`${API_URL}/api/get_sharable_dictionary_list`, {
    method: 'POST',
    headers: {
      ...headers,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify( params )
  }).then(res => res.json())

// saveDictionaryParams
export const saveDictionaryParams = (params) =>
  fetch(`${API_URL}/api/save_api_dictionary_params`, {
    method: 'POST',
    headers: {
      ...headers,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify( params )
  }).then(res => res.json())

// createNewMonitoringWordList
export const createNewMonitoringWordList = (params) =>
  fetch(`${API_URL}/api/create_new_monitoring_word_list`, {
    method: 'POST',
    headers: {
      ...headers,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify( params )
  }).then(res => res.json())

// getMontoringWordList
export const getMontoringWordList = (params) =>
  fetch(`${API_URL}/api/get_montoring_word_list`, {
    method: 'POST',
    headers: {
      ...headers,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify( params )
  }).then(res => res.json())

// getMonitoringKeywordsFromList
export const getMonitoringKeywordsFromList = (params) =>
  fetch(`${API_URL}/api/get_monitoring_keywords_from_list`, {
    method: 'POST',
    headers: {
      ...headers,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify( params )
  }).then(res => res.json())

// addOneWord2MontoringWords
export const addOneWord2MontoringWords = (params) =>
  fetch(`${API_URL}/api/add_one_word_to_montoring_words`, {
    method: 'POST',
    headers: {
      ...headers,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify( params )
  }).then(res => res.json())

// deleteOneWordFromMonitorkingWords
export const deleteOneWordFromMonitoringWords = (params) =>
  fetch(`${API_URL}/api/delete_one_word_from_monitoring_words`, {
    method: 'POST',
    headers: {
      ...headers,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify( params )
  }).then(res => res.json())

// getSharableTrackingKeywordList
export const getSharableTrackingKeywordList = (params) =>
  fetch(`${API_URL}/api/get_sharable_tracking_keyword_list`, {
    method: 'POST',
    headers: {
      ...headers,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify( params )
  }).then(res => res.json())

// getAspIdList
export const getAspIdList = (params) =>
  fetch(`${API_URL}/api/get_asp_id_list`, {
    method: 'POST',
    headers: {
      ...headers,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify( params )
  }).then(res => res.json())

// updateAspItem
export const updateAspItem = (params) =>
  fetch(`${API_URL}/api/update_asp_item`, {
    method: 'POST',
    headers: {
      ...headers,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify( params )
  }).then(res => res.json())

